var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Degree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 44.31v-11.8l6-2.29L37 18 3 30.22 18 36v16.84l.72.6A28.67 28.67 0 0037 60a29 29 0 0010.34-1.89A28.62 28.62 0 0056 52.84V36l6-2.29v10.6a3 3 0 00-1.5 2.58V52h6v-5.11a3.001 3.001 0 00-1.5-2.58zM52 51a24.84 24.84 0 01-30 0V37.47l15 5.67 15-5.67V51z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Degree.37e01a26.svg";
export { SvgK1Degree as ReactComponent };